import React from "react";
import TeamsOverviewTable from "../../Components/TeamsOverviewTable/TeamsOverviewTable";

export default function TeamsOverview() {

  return (
    <div className="container d-flex flex-column container-fluid container-md gap-3 TeamsPageParent">
      <div className="py-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Divisions & Teams Overview</h1>
        <div className="bg-white rounded-lg shadow-lg">
          <TeamsOverviewTable />
        </div>
      </div>
    </div>
  );
};